export const data = [
  {
    id: 'Emojis',
    url: 'https://tools.picsart.com/text/emojis/',
    name: 'Emojis',
  },
  {
    id: 'Background Remover',
    url: 'https://tools.picsart.com/image/background-remover/',
    name: 'Background Remover',
  },
  {
    id: 'Ai Art',
    url: 'https://picsart.com/ai-art-generator/',
    name: 'Ai Art',
  },
];
export const title = 'Discover more from Picsart';
export const data_test_id = 'test-footer-related-link';
